/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createStorageStatsResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type StorageStatsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/stats/storage
 */
export interface StorageRequestBuilder extends BaseRequestBuilder<StorageRequestBuilder> {
    /**
     * Reports how much of the organization's document allowance is in use. Every size is in bytes and the allowance is a fixed 1 GB for every organization, not something a customer can raise. Read availableSize before an upload: a file is refused when it would take the total past the allowance, and the check counts the whole file, so a 40 MB upload needs 40 MB free. Deleting documents frees the space immediately.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StorageStatsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StorageStatsResponse | undefined>;
    /**
     * Reports how much of the organization's document allowance is in use. Every size is in bytes and the allowance is a fixed 1 GB for every organization, not something a customer can raise. Read availableSize before an upload: a file is refused when it would take the total past the allowance, and the check counts the whole file, so a 40 MB upload needs 40 MB free. Deleting documents frees the space immediately.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const StorageRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/stats/storage";
/**
 * Metadata for all the requests in the request builder.
 */
export const StorageRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StorageRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createStorageStatsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
